import { render, staticRenderFns } from "./couponPop.vue?vue&type=template&id=5f0bdd30&scoped=true&"
import script from "./couponPop.vue?vue&type=script&lang=js&"
export * from "./couponPop.vue?vue&type=script&lang=js&"
import style0 from "./couponPop.vue?vue&type=style&index=0&id=5f0bdd30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0bdd30",
  null
  
)

export default component.exports